import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useAppTheme } from '@/utils/theme-context';
import { SettingsContent } from '@/components/SettingsContent';

export default function SettingsPage() {
  const navigate = useNavigate();
  const { tokens } = useAppTheme();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: tokens.bg,
        color: tokens.textPrimary,
        fontFamily: "'Syne', sans-serif",
        paddingBottom: 80,
      }}
    >
      {/* ── Header ─────────────────────────────────────────────────────── */}
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 50,
          background: tokens.bgHeader,
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '14px 16px 7px',
          paddingTop: 'calc(14px + env(safe-area-inset-top, 0px))',
          minHeight: 62,
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            width: 36, height: 36,
            borderRadius: '50%',
            background: 'transparent',
            border: 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
            color: tokens.textMuted,
            flexShrink: 0,
            transition: 'background 0.15s ease',
          }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = tokens.bgHover; }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
          aria-label="Go back"
        >
          <ChevronLeft size={22} strokeWidth={1.8} />
        </button>

        <span
          style={{
            flex: 1,
            fontSize: 18,
            fontWeight: 800,
            color: tokens.accent,
            fontFamily: "'Syne', sans-serif",
            letterSpacing: '-0.02em',
          }}
        >
          Settings
        </span>
      </div>

      {/* ── Content ────────────────────────────────────────────────────── */}
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <SettingsContent />
      </div>
    </div>
  );
}
